import "core-js/stable";
import "regenerator-runtime/runtime";

import '@/plugins/globalComponent';
import Vue from 'vue';
import App from './App.vue';
import store from '@/vuex/store';
import router from './router';
import VueChatScroll from 'vue-chat-scroll';
import VueNoty from 'vuejs-noty';
import VueSimpleAlert from "vue-simple-alert"; 
import VueToastify from 'vue-toastify'; 
import 'vuejs-noty/dist/vuejs-noty.css' 
import '@fortawesome/fontawesome-free/css/all.css';
import '@fortawesome/fontawesome-free/js/all.js'; 
import '@/css/main.css';
// import '@/plugins/sentry.js';
import '@/plugins/google-analytic.js';
import '@/plugins/filterFormat.js';
import vuetify from './plugins/vuetify';
import i18n from '@/plugins/i18n';
import { platformMixin } from './mixins/PlatformMixin';

Vue.use(VueToastify,{theme:"light"})
Vue.use(VueNoty,{timeout: 1000,progressBar: false });
Vue.use(VueSimpleAlert);
Vue.use(VueChatScroll)

Vue.mixin(platformMixin);

Vue.config.productionTip = false,  

new Vue({ 
  store,
  router,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount('#app')
 